import { ContainerModule, interfaces } from 'inversify';
import { BillingStore, IBillingStore } from './billing.store';

export const billingModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IBillingStore.$).to(BillingStore).inSingletonScope();
});
